// The producer verifies this media type for the publisher URL, independently of the stored artifact.
export function getAgencyPublisherUrl(sourceUrl: string, publisherMediaType: string | null | undefined): URL | null {
  if (publisherMediaType?.split(';', 1)[0].trim().toLowerCase() !== 'text/html') return null
  try {
    const url = new URL(sourceUrl)
    if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) return null
    return url
  } catch {
    return null
  }
}
